module.exports = __webpack_public_path__ + "img/客户案例默认图片.84593085.png";